import _ from "lodash";
export {
  isDraggable,
  isDropzone,
  sanitizeQuestionData,
  getInitPropsForNewShape,
  stableOrderizeData,
  getImageSizeWithAspectRatio,
  convertToPercentage,
  convertToPixel,
  findHighestMidPointInPolygon,
  getDragAndDropCanvasWidth,
  injectCorrectElementsInData,
  extractCorrectElementsFromData,
} from "../../DragAndDropField/DragAndDrop/DragAndDropUtils";
import { stableOrderizeData } from "./FindHotspotUtils";

/**
 *
 * @param {*} data
 * @returns convert pixel to percentage
 */
export const convertDataToPercentage = (elements, answers, fieldId, mode) => {
  const canvas = document.getElementById(
    `konva-canvas-container-id-${fieldId}-${mode}`
  );
  if (!canvas) return null;

  const canvasHeight = canvas.clientHeight;
  const canvasWidth = canvas.clientWidth;

  // * Property converter
  const convert = (item, property, dimension) => {
    if (!_.has(item, property)) return;
    const convertedValue = (_.get(item, property) / dimension) * 100;
    _.set(item, property, convertedValue);
    return convertedValue;
  };

  const elementsInPercentage = _.map(_.cloneDeep(elements), item => {
    const element = _.cloneDeep(item);
    convert(element, "x", canvasWidth);
    convert(element, "width", canvasWidth);
    convert(element, "radiusX", canvasWidth);

    convert(element, "y", canvasHeight);
    convert(element, "height", canvasHeight);
    convert(element, "radiusY", canvasHeight);
    convert(element, "fontSize", canvasHeight);

    if (_.has(element, "points")) {
      element.points = _.map(element.points, (point, index) => {
        return (point / (index % 2 === 0 ? canvasWidth : canvasHeight)) * 100;
      });
    }

    return element;
  });

  const answersInPercentage = _.map(_.cloneDeep(answers), item => {
    const answer = _.cloneDeep(item);
    convert(answer, "x", canvasWidth);
    convert(answer, "y", canvasHeight);
    return answer;
  });

  return {
    elements: elementsInPercentage,
    answers: answersInPercentage,
  };
};

/**
 *
 * @param {*} data
 * @returns convert percentage to pixel
 */
export const convertDataToPixel = async (
  fieldValue,
  fieldId,
  mode,
  onConvert = () => {}
) => {
  const canvas = document.getElementById(
    `konva-canvas-container-id-${fieldId}-${mode}`
  );
  if (!canvas) {
    // * retry till canvas is not added into dom
    await new Promise(resolve => setTimeout(() => resolve(), 100));
    return convertDataToPixel(fieldValue, fieldId, mode, onConvert);
  }

  const elements = _.get(fieldValue, "elements", []);
  const answers = _.get(fieldValue, "answers", []);

  const canvasHeight = canvas.clientHeight;
  const canvasWidth = canvas.clientWidth;

  // * Property converter
  const convert = (item, property, dimension) => {
    if (!_.has(item, property)) return;
    _.set(
      item,
      property,
      (parseFloat(_.get(item, property)) / 100) * dimension
    );
  };

  // * Converting elements
  const updatedData = _.map(elements, item => {
    const element = _.cloneDeep(item);

    convert(element, "x", canvasWidth);
    convert(element, "width", canvasWidth);
    convert(element, "radiusX", canvasWidth);

    convert(element, "y", canvasHeight);
    convert(element, "height", canvasHeight);
    convert(element, "radiusY", canvasHeight);
    convert(element, "fontSize", canvasHeight);

    if (_.has(element, "points")) {
      element.points = _.map(element.points, (point, index) => {
        return (point / 100) * (index % 2 === 0 ? canvasWidth : canvasHeight);
      });
    }

    return element;
  });

  // * Converting answers
  const updatedAnswers = _.map(answers, item => {
    const element = _.cloneDeep(item);
    convert(element, "x", canvasWidth);
    convert(element, "y", canvasHeight);
    return element;
  });

  onConvert({ elements: updatedData, answers: updatedAnswers });
};

/**
 *
 * @param {*} data
 * @param {*} mode
 * @param {*} findHotspotAnswers
 * @returns mapping draggable state, according to user and mode
 */
export const sanitizeHotspotQuestionData = (data, { mode, drawMode }) => {
  const mappedData = _.map(data, item => {
    const itemObject = { ...item };

    if (mode === "create" && !_.get(drawMode, "isDrawing")) {
      itemObject.draggable = true;
    } else {
      itemObject.draggable = false;
    }
    return itemObject;
  });

  return stableOrderizeData(mappedData);
};
